/**
 * Singular of a school's attendee label ("Children" → "Child"), for the
 * checkout's per-seat headings and the dashboard's preview of them, so both
 * say the same word.
 */
export function singularizeParticipantLabel(label: string): string {
  const l = label.trim();
  if (/ren$/i.test(l)) return l.replace(/ren$/i, ""); // Children → Child
  if (/ies$/i.test(l)) return l.replace(/ies$/i, "y"); // Puppies → Puppy
  if (/s$/i.test(l)) return l.replace(/s$/i, ""); // Students → Student
  return l;
}
